"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataOutdated = exports.setCachedData = exports.getCachedData = void 0;
const getCachedData = (key) => {
    try {
        const cachedHeaderItem = localStorage.getItem(key);
        return cachedHeaderItem ? JSON.parse(cachedHeaderItem) : null;
    }
    catch (_a) {
        return null;
    }
};
exports.getCachedData = getCachedData;
const setCachedData = (key, data, memberId, siteId, path) => {
    if (!data || !siteId || !memberId)
        return;
    try {
        localStorage.setItem(key, JSON.stringify({ data, siteId, memberId, path, date: new Date() }));
    }
    catch (_a) {
        localStorage.removeItem(key);
    }
};
exports.setCachedData = setCachedData;
const isDataOutdated = (cachedData, expirationInMinute, memberId, siteId, path) => {
    try {
        if (!cachedData)
            return true;
        const now = new Date();
        const since = new Date(cachedData.date);
        const isExpired = now.getTime() - since.getTime() > expirationInMinute * 1000 * 60;
        const siteIdChanged = cachedData.siteId !== siteId;
        const memberIdChanged = cachedData.memberId !== memberId;
        const pathChanged = cachedData.path !== path;
        return isExpired || siteIdChanged || memberIdChanged || pathChanged;
    }
    catch (_a) {
        return true;
    }
};
exports.isDataOutdated = isDataOutdated;
